import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const returnResonsFn = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.returnResons, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
